export default {"src":"/_next/static/media/slope.6b304092.svg","height":116,"width":116,"blurWidth":0,"blurHeight":0};